<section class="py-6 max-w-[850px] h-[600px] flex flex-col items-center justify-center">
    <h2 class="text-xl font-bold text-font-primary">Your COD has been created!</h2>
    <p class="mb-4 mt-1 text-xs text-font-secondary">You will be redirected to the dashboard in less then 3 seconds.</p>
    <sag-ui-spinner size="lg"></sag-ui-spinner>
</section>
